<template>
  <scout-topic-panel
    title="送信候補"
    name="review"
    tooltip="貴社がスカウトやいいねの送信を検討している会員を一時保存することができます。"
    data-test="panel-review"
  >
    <router-link
      :to="{ name: 'scoutUnderReview', params: { contractId: contractId, jobId: jobId + ''} }"
      class="pega-text-link"
    >
      <span
        data-test="count"
        class="boss-scoutandlike-text"
      >{{ count }}名
      </span>
    </router-link>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'

export default {
  components: { ScoutTopicPanel },
  props: {
    jobId: {
      type: Number,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      default: 0
    }
  }
}

</script>
